<template>
  <div class="OTP">
    <v-container>
      <div class="text-center incenter-logo">
        <a href="/">
          <v-img
            src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
            height="100"
            width="200"
            class="mx-auto"
          ></v-img>
        </a>
      </div>
      <v-card raised class="mx-auto" max-width="700">
        <div class="my-5 text-center">
          <span>Isi data diri anda</span>
          <div>
            <b>{{ words }}</b>
          </div>
          <div class="pa-5">
            <v-form ref="data" v-model="valid" lazy-validation="">
              <v-text-field
                v-model="nama"
                type="text"
                label="Nama anda"
                flat
                hide-no-data
                hide-details
                solo-inverted
              ></v-text-field>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="kota"
                    :items="city"
                    flat
                    hide-no-data
                    hide-details
                    label="Kota"
                    item-text="city_name"
                    item-value="city_id"
                    solo-inverted
                  ></v-autocomplete>
                </v-col>
                <v-col v-if="kota != null">
                  <v-autocomplete
                    v-model="kecamatan"
                    :items="subdistrict"
                    flat
                    hide-no-data
                    hide-details
                    label="Kecamatan"
                    solo-inverted
                  ></v-autocomplete>
                </v-col>
                <v-col v-if="kecamatan != null">
                  <v-text-field
                    v-model="kodepos"
                    type="number"
                    label="Kodepos"
                    flat
                    hide-no-data
                    hide-details
                    solo-inverted
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="alamat"
                    type="text"
                    label="Alamat Rumah"
                    flat
                    hide-no-data
                    hide-details
                    solo-inverted
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </div>

        <v-card-actions>
          <v-btn @click="daftar()" text block color="deep-purple accent-4">
            Lanjutkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="overlay" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      valid: true,
      words: this.$route.params.handphone,
      overlay: false,
      nama: null,
      alamat: null,
      kodepos: null,
      kota: null,
      kecamatan: null,
      city: [],
      subdistrict: [],
    };
  },
  mounted() {
    this.getKota();
  },
  methods: {
    daftar(data) {
      console.log(data);
    },
    getKota() {
      fetch("http://meridinet.saebo.id:2082/Login/api/viewkota")
        .then((response) => response.json())
        .then((data) => {
          var obj = data.data;

          this.city = obj;
        });
    },
  },
};
</script>
